// src/components/MainMenu.js
import React from 'react';

const MainMenu = ({ onStart }) => {
  return (
    <div className="main-menu">
      <h1>Nuestra pequeña aventura</h1>
      <button onClick={onStart}>Comenzar</button>
    </div>
  );
};

export default MainMenu;